import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="font-sans bg-ink text-white">
      {/* Hero Section */}
      <section className="panel-surface text-white section-padding font-display">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
            Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
          </p>
          <div className="mt-6">
            <div className="badge-official">Last Updated: December 2024</div>
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <div className="space-y-12">
            
            {/* Introduction */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Introduction
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Information We Collect */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Information We Collect
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4 font-display">Personal Information</h3>
                  <div className="space-y-3 text-gray-300 font-sans">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. We may collect:</p>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Name, email address, and contact information
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Payment and billing information
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Device and usage information
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Location data and preferences
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4 font-display">Automatically Collected Data</h3>
                  <div className="space-y-3 text-gray-300 font-sans">
                    <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua:</p>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        IP address and browser information
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        Cookies and tracking technologies
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        Usage patterns and analytics data
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* How We Use Information */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                How We Use Your Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-gradient-to-br from-primary to-accent-warm rounded-lg flex items-center justify-center mr-4 mt-1">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white font-display">Service Delivery</h4>
                      <p className="text-sm text-gray-300 font-sans">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-gradient-to-br from-accent-warm to-primary rounded-lg flex items-center justify-center mr-4 mt-1">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white font-display">Communication</h4>
                      <p className="text-sm text-gray-300 font-sans">Ut enim ad minim veniam, quis nostrud exercitation.</p>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-gradient-to-br from-accent-success to-primary rounded-lg flex items-center justify-center mr-4 mt-1">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white font-display">Analytics</h4>
                      <p className="text-sm text-gray-300 font-sans">Duis aute irure dolor in reprehenderit in voluptate.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-gradient-to-br from-primary to-accent-success rounded-lg flex items-center justify-center mr-4 mt-1">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-white font-display">Security</h4>
                      <p className="text-sm text-gray-300 font-sans">Excepteur sint occaecat cupidatat non proident.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Information Sharing */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Information Sharing
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Your Rights */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Your Rights
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  { title: "Access", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
                  { title: "Correction", desc: "Sed do eiusmod tempor incididunt ut labore et dolore." },
                  { title: "Deletion", desc: "Ut enim ad minim veniam, quis nostrud exercitation." },
                  { title: "Portability", desc: "Duis aute irure dolor in reprehenderit in voluptate." }
                ].map((right, index) => (
                  <div key={index} className="panel-surface p-6 rounded-lg">
                    <h4 className="font-semibold text-white mb-2 font-display">{right.title}</h4>
                    <p className="text-sm text-gray-300 font-sans">{right.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Information */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Contact Us
              </h2>
              <div className="space-y-4 text-gray-300 font-sans">
                <p>
                  If you have any questions about this Privacy Policy, please contact us:
                </p>
                <div className="space-y-2">
                  <p><strong className="text-white">Email:</strong> privacy@ibtsports.com</p>
                  <p><strong className="text-white">Phone:</strong> +1 (800) IBT-SPORT</p>
                  <p><strong className="text-white">Address:</strong> 123 Sports Avenue, Suite 500, New York, NY 10001</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
